<template>
    <div id="tbq-footer" class="flex flex-col justify-center items-center gap-y-8 md:gap-y-10 w-full">
        <div
            id="footer-logo-img"
            class="mask self-start md:self-center w-auto h-auto logo-link inline-flex"
            :style="`background-color: ${logoColor}`"
        >
            <img class="w-full" src="../assets/logo.png" alt="Topbar TheBigQuiz Logo" />
            <!-- <div class="mask" :style="`background-color: ${logoColor}`">

            </div> -->
        </div>
        <nav class="menu-box self-start md:self-center md:flex md:justify-center md:items-center w-full">
            <a
                v-for="(menu, index) in menus.filter(e => e.visible)"
                @click="menu.action"
                :key="index"
                class="menu block font-size-14 font-bold cursor-pointer"
                link
            >
                {{ $t(menu.label) }}
            </a>
        </nav>
        <span class="copyright font-size-14">
            {{ $t('footer_menu_copyright', { year: new Date().getFullYear() }) }}
        </span>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { currentUser } from '@/lib/user'

export default {
    props: {
        logoColor: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            menus: [
                {
                    label: 'footer_menu_newsletter',
                    action: () => {
                        this.$store.commit('setShowNewsletterModal', true)
                    },
                    visible: true
                },
                {
                    label: 'footer_menu_purchase',
                    action: () => {
                        if (currentUser()) {
                            if (currentUser().provider === 'feide') {
                                return (window.location.href = this.$router.resolve({ name: 'skoler-purchase' }).href)
                            }

                            if (currentUser().role.includes('teacher')) {
                                return (window.location.href = this.$router.resolve({ name: 'school-purchase' }).href)
                            }
                        }

                        if (this.isSkolerPage()) {
                            return (window.location.href = this.$router.resolve({ name: 'skoler-purchase' }).href)
                        }

                        if (this.isSchoolPage()) {
                            return (window.location.href = this.$router.resolve({ name: 'school-purchase' }).href)
                        }

                        return (window.location.href = this.$router.resolve({ name: 'purchase' }).href)
                    },
                    visible: true
                },
                {
                    label: 'footer_menu_question_and_answer',
                    action: () => {
                        const data = this.subPageMenu.find(
                            content => content.slug === 'qa' || (content.name && content.name.toLowerCase() === 'q&a')
                        )

                        this.openPageContent(data)
                    },
                    visible: true
                },
                {
                    label: 'footer_menu_support',
                    action: () => {
                        const data = this.subPageMenu.find(
                            content =>
                                content.slug === 'support' || (content.name && content.name.toLowerCase() === 'support')
                        )

                        this.openPageContent(data)
                    },
                    visible: true
                },
                {
                    label: 'footer_menu_school',
                    action: () => {
                        if (
                            this.$route.name.indexOf('skoler') > -1 ||
                            (currentUser() && currentUser().provider === 'feide')
                        ) {
                            location.href = '/skoler'
                        } else {
                            location.href = '/school'
                        }
                    },
                    visible: true
                },
                {
                    label: 'footer_menu_privacy_policy',
                    action: () => {
                        const data = this.subPageMenu.find(
                            content =>
                                content.slug === 'privacy-policy' ||
                                (content.name && content.name.toLowerCase() === 'privacy policy')
                        )

                        this.openPageContent(data)
                    },
                    visible: true
                }
            ]
        }
    },

    computed: {
        ...mapState({
            subPageMenu: state => state.subPageMenu
        })
    },

    methods: {
        openPageContent(content) {
            if (!content) return

            if (content.is_slide) {
                this.$store.commit('setPageSliderPopup', { show: true, slug: content.slug })
            } else {
                location.href = `/article/${content.slug}`
            }
        }
    }
}
</script>

<style lang="scss">
#tbq-footer {
    row-gap: 28px;
    padding: 28px 14px 84px 14px;
    background-color: var(--background-color);

    @media screen and (min-width: 768px) {
        row-gap: 35px;
        padding: 84px 14px;
    }
    #footer-logo-img {
        // object-fit: contain;

        &.mask {
            -webkit-mask-image: url(../assets/logo.png);
            -webkit-mask-size: contain;
            -webkit-mask-repeat: no-repeat;
            mask-image: url(../assets/logo.png);
            mask-size: contain;
            mask-repeat: no-repeat;

            img {
                visibility: hidden;
                object-fit: contain;

                width: 35svmin;
                aspect-ratio: 2.2857142857;
                visibility: hidden;

                @media (min-aspect-ratio: 0.62) {
                    width: 24svmin;
                }
            }
        }
    }

    .menu-box {
        columns: 2;

        @media screen and (min-width: 768px) {
            columns: 1;
            column-gap: 42px;
        }

        .menu {
            margin-bottom: 21px;
            color: var(--ui-primary-color);
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }

            @media screen and (min-width: 768px) {
                margin-bottom: 0;
            }
        }
    }

    .copyright {
        margin-top: 35px;
        color: var(--ui-primary-color);
    }
}
</style>
